import { useState, useEffect } from 'react';
import { useHits } from 'react-instantsearch';
import { MagnifyingGlass, ArrowRight } from '@phosphor-icons/react';
import { searchClient } from '../../services/algoliaClient';
import { useTranslation } from 'react-i18next';

// Query Suggestions Component using InstantSearch Index
export const QuerySuggestionsFromIndex = ({ onSuggestionSelect }) => {
  const { t } = useTranslation();
  const { items } = useHits();

  return (
    <div style={{ width: '100%' }}>
      {/* Section Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '16px',
          fontWeight: '600',
          color: '#4B164C'
        }}>
          <MagnifyingGlass size={18} />
          <span>{t('suggestions')}</span>
        </div>
      </div>

      {/* Suggestions List */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
        {items.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => onSuggestionSelect(suggestion.query)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              background: 'transparent',
              border: 'none',
              padding: '12px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textAlign: 'left',
              width: '100%'
            }}
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = '#f8f6fa';
              e.currentTarget.style.borderColor = '#4B164C';
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <MagnifyingGlass size={16} color="#888" />
            <span style={{
              flex: 1,
              fontSize: '14px',
              color: '#4B164C',
              fontWeight: '500',
              textAlign: 'left'
            }}>
              {suggestion.query}
            </span>
            <ArrowRight size={14} color="#888" />
          </button>
        ))}
      </div>
    </div>
  );
};

// Original Query Suggestions Component (for fallback)
export const QuerySuggestions = ({ query, onSuggestionSelect }) => {
  const { t } = useTranslation();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query || query.length < 2) {
      setSuggestions([]);
      return;
    }

    const fetchSuggestions = async () => {
      setLoading(true);
      try {
        const response = await searchClient.search([{
          indexName: 'saq_products_query_suggestions',
          params: {
            query,
            hitsPerPage: 5
          }
        }]);
        
        setSuggestions(response.results[0].hits || []);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    };

    const timeoutId = setTimeout(fetchSuggestions, 150);
    return () => clearTimeout(timeoutId);
  }, [query]);

  if (loading || suggestions.length === 0) return null;

  return (
    <div style={{ width: '100%' }}>
      {/* Section Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '16px',
          fontWeight: '600',
          color: '#4B164C'
        }}>
          <MagnifyingGlass size={18} />
          <span>{t('suggestions')}</span>
        </div>
      </div>

      {/* Suggestions List */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => onSuggestionSelect(suggestion.query)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              background: 'transparent',
              border: 'none',
              padding: '12px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textAlign: 'left',
              width: '100%'
            }}
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = '#f8f6fa';
              e.currentTarget.style.borderColor = '#4B164C';
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <MagnifyingGlass size={16} color="#888" />
            <span style={{
              flex: 1,
              fontSize: '14px',
              color: '#4B164C',
              fontWeight: '500',
              textAlign: 'left'
            }}>
              {suggestion.query}
            </span>
            <ArrowRight size={14} color="#888" />
          </button>
        ))}
      </div>
    </div>
  );
}; 